"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            /** Tree node container React class. */
            // tslint:disable-next-line: class-name
            var _TreeNodeContainer = /** @class */ (function (_super) {
                __extends(_TreeNodeContainer, _super);
                function _TreeNodeContainer() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                /**
                 * Implementation of render function.
                 * @returns The content to render.
                 */
                _TreeNodeContainer.prototype.render = function () {
                    var listStyles = { listStyleType: "none" };
                    return (React.createElement("ul", { className: "treeView-treeItem-children", style: listStyles, tabIndex: -1, role: "tree", "aria-multiselectable": "true" }, this.renderTreeNodes(this.props.Nodes)));
                };
                /**
                 * Renders the children nodes.
                 * @param nodes The tree node contracts.
                 * @returns The tree node components.
                 */
                _TreeNodeContainer.prototype.renderTreeNodes = function (nodes) {
                    var output = [];
                    var parentNode;
                    for (var i = 0; i < nodes.length; i++) {
                        if (nodes[i].index !== i || nodes[i].siblingSize !== nodes.length) {
                            nodes[i].index = i;
                            nodes[i].siblingSize = nodes.length;
                            nodes[i].renderPending = true;
                            if (nodes[i].ParentId && nodes[i].Tree && nodes[i].Tree.idMap) {
                                parentNode = nodes[i].Tree.idMap[nodes[i].ParentId];
                            }
                            if (parentNode && parentNode.ariaLevel) {
                                nodes[i].ariaLevel = parentNode.ariaLevel + 1;
                            }
                            else {
                                nodes[i].ariaLevel = 1;
                            }
                        }
                        output.push(React.createElement($dyn.DynReact.UI.TreeNode, { key: nodes[i].Id, node: nodes[i] }, this.renderTreeNodes(nodes[i].Nodes)));
                    }
                    return output;
                };
                return _TreeNodeContainer;
            }(React.Component));
            UI._TreeNodeContainer = _TreeNodeContainer;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TreeNodeContainer.js.map
